<script setup>

import LoaderIcon from '@/components/CustomIcons/LoaderIcon.vue';
import CoursesCarousel from '@/components/landing/courses/CoursesCarousel.vue';
</script>

<template>
  <div class="bg-primary py-8 md:py-24 sm:px-2 lg:px-4 text-md text-basecolor">
    <div class="mx-auto max-w-7xl px-6">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <div class="max-w-3xl">
          <h2 class="text-3xl font-bold tracking-tight ">
            {{ $t("landingPage.coursesSection.title") }}
          </h2>
        </div>
        <div class="mt-14 grid xl:grid-cols-2 grid-cols-1 gap-x-24 gap-y-10 mb-12">
          <div>
            <h3 class="text-2xl font-bold tracking-tight">
              {{ $t("landingPage.coursesSection.subtitle") }}
            </h3>
            <p class="mt-12">
              {{ $t("landingPage.coursesSection.text") }}
            </p>
          </div>
          <div>
            <!-- Carousel section -->
            <div class="xl:mx-auto xl:max-w-7xl xl:px-8">
              <CoursesCarousel />
            </div>
          </div>
        </div>

        <div class="text-xl font-semibold rounded-3xl bg-white px-8 py-3 inline">
          <LoaderIcon class="inline w-6 text-secondary stroke-secondary pb-1" />
          {{ $t("landingPage.coursesSection.moreComing") }}
        </div>
      </div>
    </div>
  </div>
</template>
